import React from "react";
import { ADMIN_TASK_STATUS_OPTIONS } from "./adminStatusUi";

/**
 * Four-stage client pipeline: pick the stage that matches reality (not a strict linear wizard).
 */
export default function AdminStatusWorkflow({
  id: idPrefix = "status-workflow",
  ariaLabelledBy,
  value,
  onChange,
  disabled = false,
}) {
  const active =
    ADMIN_TASK_STATUS_OPTIONS.find((o) => o.value === value) || ADMIN_TASK_STATUS_OPTIONS[0];
  const groupLabelledBy = ariaLabelledBy || `${idPrefix}-legend`;

  return (
    <div className="admin-dash__status-workflow">
      {!ariaLabelledBy ? (
        <span id={`${idPrefix}-legend`} className="admin-dash__sr-only">
          Pipeline stage
        </span>
      ) : null}
      <div className="admin-dash__status-workflow-grid" role="radiogroup" aria-labelledby={groupLabelledBy}>
        {ADMIN_TASK_STATUS_OPTIONS.map((opt, index) => {
          const isActive = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={isActive}
              disabled={disabled}
              className={`admin-dash__status-workflow-card ${
                isActive ? "admin-dash__status-workflow-card--active" : ""
              } admin-dash__status-workflow-card--${opt.value.replace(/_/g, "-")}`}
              onClick={() => onChange(opt.value)}
            >
              <span className="admin-dash__status-workflow-card-index" aria-hidden="true">
                {index + 1}
              </span>
              <span className="admin-dash__status-workflow-card-label">{opt.label}</span>
              <span className="admin-dash__status-workflow-card-short">{opt.short}</span>
            </button>
          );
        })}
      </div>
      <p className="admin-dash__status-workflow-hint" id={`${idPrefix}-hint`}>
        <span
          className={`admin-dash__status-workflow-hint-pill admin-dash__status-workflow-hint-pill--${active.value.replace(
            /_/g,
            "-"
          )}`}
        >
          {active.label}
        </span>
        <span className="admin-dash__status-workflow-hint-text">{active.hint}</span>
      </p>
    </div>
  );
}
